import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaBars, FaHome, FaLock, FaMoneyBill, FaUser } from "react-icons/fa";
import { loader } from "../../redux/type";
import { auth } from "../../redux/type";
import { Link, useNavigate, useLocation } from "react-router-dom";

const SwitchUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  console.log("DATATATA=", userData);

  // const id = userData?.user?.id;
  const id = userData?.domainCodesByUserId[0]?.userId;
  const name2 = userData?.user?.firstName;

  const userData2 = JSON.parse(localStorage.getItem("user1"));
  const token1 = localStorage.getItem("token1");
  const adminDeptList = userData2?.domainCodesByUserId;
  console.log("NEWDATA=", userData2);

  function adminDeptLogin(ind) {
    if (
      (adminDeptList[ind].domainCode === "AA") &
        (adminDeptList[ind].typeofUser === 1) ||
      adminDeptList[ind].userTypeName === "Admin"
    ) {
      localStorage.setItem("userType", 1);
      localStorage.setItem("token", token1);
      dispatch({
        type: auth.login,
        payload: userData2,
      });

      navigate("/deptDashboard");

      window.location.reload();
    } else {
      localStorage.setItem("userType", 2);
      localStorage.setItem("token", token1);
      dispatch({
        type: auth.login,
        payload: userData2,
      });

      navigate("/deptUserDashboard");
      window.location.reload();
    }
  }

  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4 className="h2_heading"> Select User</h4>

         
        

          <div className="row">
            {adminDeptList?.map((val, index) => (
              <>
                {(adminDeptList[index]?.domainCode === "AA") &
                  (adminDeptList[index]?.typeofUser === 1) ||
                adminDeptList[index]?.userTypeName === "Admin" ? (
                  <>
                    <div className="card marTop shadow cardDash1 ">
                    <div className="card-body"  onClick={() => {
                        adminDeptLogin(index);
                      }}>
                   
                      <FaUser
                        className="iconSize2 mt-3"
                       
                      />

                      <h5 style={{ color: "black" }}>
                        {" "}
                        {adminDeptList[index]?.domainName} Admin
                      </h5>
                    
                    </div>
                    </div>
                    
                  </>
                  
                ) : (
                  <>
                    <div className="card marTop shadow cardDash1 ">
                    <div className="card-body"   onClick={() => {
                          adminDeptLogin(index);
                        }}>
                   
                      <FaUser
                        className="iconSize2 mt-3"
                      
                      />

                      <h5 style={{ color: "black" }}>
                        {adminDeptList[index]?.domainName} Department User
                      </h5>
                    
                    </div>
                    </div>
                  </>
                )}
              </>
            ))}

            {/* <div className="col-3 switchUserCard  ">
              <FaUser className="iconSize2 mt-3" style={{ color: "white" }} />

              <h5 style={{ color: "black" }}>Admin</h5>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default SwitchUser;
